export const queryURL = (newStatus, apiUrl, customerId) => {
  return newStatus === "SKIPPED"
    ? `${apiUrl}/api/customers/${customerId}/charges/skip`
    : `${apiUrl}/api/customers/${customerId}/charges/unskip`;
};

export const dietTypeSubtitle = (mealsList) => {
  let _data = [...mealsList];

  if (!_data.length) return "Low-FODMAP";

  const sku = _data[0]?.variants?.[0]?.sku;
  
  if (!sku || typeof sku !== 'string') {
    console.warn('[dietTypeSubtitle] Invalid SKU:', sku, 'for meal:', _data[0]);
    return "Low-FODMAP";
  }

  if (sku.startsWith("MD")) {
    return "Mediterranean";
  }
  if (sku.startsWith("LF")) {
    return "Low-FODMAP";
  }
  if (sku.startsWith("DF")) {
    return "Diabetes-Friendly";
  }
  if (sku.startsWith("GF")) {
    return "Gluten-Free";
  }
  if (sku.startsWith("HF")) {
    return "Heart-Friendly";
  }
  if (sku.startsWith("CC")) {
    return "Carb-Conscious";
  }
  if (sku.startsWith("B2B")) {
    return "B2B";
  }
  if (sku.startsWith("MCD")) {
    return "Care";
  }
  if (sku.startsWith("GL")) {
    return "GLP-1";
  }
  
  return "Low-FODMAP";
};

